export default __webpack_public_path__ + "static/media/card-vale-social.fc642d14.png";